import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isLoader:false,
  allCategory:[],
}

export const CategorySlice = createSlice({
  name: 'allCategories',
  initialState,
  reducers: {
    getCategoryStart: (state,action) => {
        state.isLoader= true
    },
    getCategorySuccess: (state,action) => {
        state.isLoader= false
        state.allCategory = action.payload
    },
    deleteCategory:(state,action) => {
      state.isLoader = true
      state.allCategory = state.allCategory.filter((elem)=>elem._id !== action.payload)
      state.isLoader = false

    },
    updateCategory: (state,action) => {
      const Index = state.allCategory.findIndex(Category => Category._id === action.payload._id);
      if(Index !== -1 ){
        state.allCategory[Index] = action.payload;
      }
    }
  },
})

export const {getCategoryStart, getCategorySuccess, deleteCategory, updateCategory} = CategorySlice.actions

export default CategorySlice.reducer